import React from 'react';
import PropTypes from 'prop-types';
import { Flex } from '@rebass/grid';
import styled from 'styled-components';

const Wrapper = styled(Flex)`
  padding: 16px;
  border-top: 1px solid #ddd;
`;

const Footer = ({ children }) => (
  <Wrapper justifyContent="flex-end">
    {children}
  </Wrapper>
);

Footer.propTypes = {
  children: PropTypes.node
};

export default Footer;



// WEBPACK FOOTER //
// ./src/app/admin/components/Modal/Footer.js